/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Next_WeekInputs */

const en_plan_next_week = /** @type {(inputs: Plan_Next_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next week`)
};

const de_plan_next_week = /** @type {(inputs: Plan_Next_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Woche`)
};

/**
* | output |
* | --- |
* | "Next week" |
*
* @param {Plan_Next_WeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_next_week = /** @type {((inputs?: Plan_Next_WeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Next_WeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_next_week(inputs)
	return en_plan_next_week(inputs)
});